import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import "react-image-crop/dist/ReactCrop.css";
import { Button } from "@material-ui/core";
import { enableProvider } from "../../../../../services/api";
import { useSnackbar } from "notistack";
import { useState } from "react";

function RejectionModal(props) {
    const { enqueueSnackbar } = useSnackbar();
    const [textValue, setTextValue] = useState("");
    const [loading, setLoading] = useState(false);

    const {
        open,
        onClose,
        data,
        setRejectModal,
        fetchProviders,
        classes: { modal, modalContent, button, span },
    } = props;
    const handleClose = () => {
        setRejectModal(false)
    }

    const disabLeProviders = async (data) => {
        const disableData = {
            id: data.id,
            enable: false,
            reason: textValue,
        };

        if (disableData.reason === "") {
            enqueueSnackbar("Please provide a reason!");
        } else {
            try {
                setLoading(true)
                enableProvider(disableData)
                enqueueSnackbar("Profile Deactivated succesfully!");
                handleClose()
                }                           
                catch (err) {
                console.error("ERR OCCURED IN enableProviders :::", err);
                enqueueSnackbar("Unable to update active status on provider.");
            } finally {
                setTimeout(async() => {
                    setLoading(false)
                    await fetchProviders();
                }, 1000);
                // setLoading(false)
                // await fetchProviders();
            }
        }
    };
    return (
        <Dialog
            maxWidth={"md"}
            open={open}
            // disableBackdropClick
            onClose={onClose}
            classes={{ paper: modal }}
        >
            <DialogTitle>Reason for deactivating {data.name}'s profile </DialogTitle>
            <DialogContent classes={{ root: modalContent }}>
                <textarea
                    id="w3review"
                    name="w3review"
                    rows="5"
                    style={{ padding: "10px" }}
                    onChange={(e) => {
                        setTextValue(e.target.value);
                    }}
                    placeholder="Please provide a valid reason for deactivating this profile.."
                    cols="50"
                ></textarea>
            </DialogContent>
            <span className={span}>
                <Button
                    onClick={() => { disabLeProviders(data) }}
                    variant="contained"
                    color="primary"
                    className={button}
                    disabled={loading}
                    disabledDuringOnClick
                >
                    {" "}
                    Inactive
                </Button>

                <Button
                    onClick={onClose}
                    variant="contained"
                    color="primary"
                    className={button}
                >
                    Cancel
                </Button>
            </span>
        </Dialog>
    );
}

RejectionModal.propTypes = {
    open: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

const styles = () => ({
    modal: {
        maxHeight: "1000px",
    },
    modalContent: {
        overflow: "visible",
        padding: "10px",
        marginTop: "10px",
        textAlign: "center",
    },
    title: {
        marginTop: "10px",
        marginLeft: "auto",
        marginRight: "auto",
        padding: "5px",
    },
    button: {
        width: "100px",
        margin: "10px",
    },
    span: {
        margin: "auto",
        marginTop: "0px",
    },
});

export default withStyles(styles)(RejectionModal);
